<template>
  <div>
    <!-- <div style="line-height: 22px;" class="c9 mb10">注：请先完成线下商户号充值操作，再进行线上返现操作。</div> -->
    <div class="flex_between search">
      <div class="left flex1">
        <el-form :model="form" label-width="52px" label-suffix=":">
          <div class="form-box">
            <el-form-item label="日期" class="formItem">
              <el-date-picker v-model="form.year" :editable="false" :picker-options="expireTimeOption" :clearable="true" value-format="yyyy" placeholder="请选择月份" type="year" />
            </el-form-item>
            <div>
              <el-button type="primary" @click="query">查询</el-button>
              <el-button @click="resetForm">重置</el-button>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="total_box mb22">累计返现金额：<span class="active_color">￥{{ $formatCurrency(cashback_sum) || '0.00' }}</span></div>
    <zf-table
      :columns="column"
      :data-source="tableList"
      :pagination="false"
    >
      <!-- 返现金额 -->
      <template
        slot="final_price"
        slot-scope="{ row }"
      >
        <span>￥{{ $formatCurrency(row.final_price) || '0.00' }}</span>
      </template>
      <!-- 商户号充值金额 -->
      <template
        slot="mch_price"
        slot-scope="{ row }"
      >
        <span>￥{{ $formatCurrency(row.mch_price) || '0.00' }}</span>
      </template>
      <!-- 服务费率 -->
      <template
        slot="rate"
        slot-scope="{ row }"
      >
        <span>{{ row.rate }}%</span>
      </template>
      <!-- 服务费 -->
      <template
        slot="service_price"
        slot-scope="{ row }"
      >
        <span>￥{{ $formatCurrency(row.service_price) || '0.00' }}</span>
      </template>
      <!-- 状态 -->
      <template
        slot="cashback_status"
        slot-scope="{ row }"
      >
        <span v-if="row.cashback_status == 2" class="ableuse_bg plub_width inline">已返现</span>
        <span v-else-if="row.cashback_status == 0" class="wait_bg plub_width inline">待确认</span>
        <span v-else-if="row.cashback_status == 1" class="wait_bg plub_width inline">待返现</span>
        <span v-else-if="row.cashback_status == -3" class="nouse_bg plub_width inline" style="width:74px">平台撤销</span>
        <span v-else-if="row.cashback_status == -2" class="no_bg plub_width inline" style="width:74px">平台拒绝</span>
        <span v-else-if="row.cashback_status == -1" class="no_bg plub_width inline" style="width:74px">客户拒绝</span>
      </template>
      <!-- 操作 -->
      <template
        slot="action"
        slot-scope="{ row }"
      >
        <a v-if="row.recharge_id && powerReg('c81ea23fc85cb07dcf6a04d751631d64')" class="active_color" @click="detail(row)">详情</a>
        <el-divider v-if="row.recharge_id && powerReg('c81ea23fc85cb07dcf6a04d751631d64') && row.cashback_status == 0" direction="vertical" />
        <a v-if="row.cashback_status == 0 && powerReg('b1dfbce59e30ac0ad13ed8e230e6e564')" class="active_color" @click="sure(row)">确认</a>
        <el-divider v-if="row.cashback_status == 0 && powerReg('11dc5b4542d337e056d8fc12b10d53eb')" direction="vertical" />
        <a v-if="row.cashback_status == 0 && powerReg('11dc5b4542d337e056d8fc12b10d53eb')" class="del" @click="refuse(row)">拒绝</a>
      </template>
    </zf-table>
    <ModelPayee :visible.sync="dialogFormVisible" :source="detailValue" @submitFn="submitFn" />
    <el-dialog
      title="详情"
      :visible.sync="detailVisible"
      width="400px"
      center
    >
      <div class="detail-con">
        <el-row class="mb20">
          <el-col :span="12">
            <div class="fs16" style="color:#000;">返现金额: ￥{{ $formatCurrency(returnMoneyDetail.recharge_price) || 0 }}</div>
          </el-col>
          <el-col :span="12">
            <div class="fs16" style="color:#000;">服务费: ￥{{ $formatCurrency(returnMoneyDetail.service_price) || 0 }}</div>
          </el-col>
        </el-row>
        <div class="tit mb10">商户号充值金额：￥{{ $formatCurrency(returnMoneyDetail.mch_price) || '0.00' }}</div>
        <div style="max-height:250px;overflow:auto;">
          <div v-for="(item, index) in returnMoneyDetail.detail" :key="index" class="mch-item">
            <div>商户号：{{ item.mch_id }}</div>
            <div class="mt10">充值金额：￥{{ $formatCurrency(item.price) || '0.00' }}</div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false">取 消</el-button>
        <el-button type="primary" @click="detailVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="拒绝"
      :visible.sync="refuseVisible"
      width="30%"
      center
    >
      <el-form :model="refuseForm" :rules="refuseFormRules">
        <el-form-item label="拒绝理由：" prop="reason">
          <el-input v-model="refuseForm.reason" type="textarea" :rows="4" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="refuseVisible = false">取 消</el-button>
        <el-button type="primary" @click="reasonFn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ZfTable from '@/components/ZfTable/CoreTable'
import column from '../columns/returnMoneyRecord'
import ModelPayee from './ModelPayee'
import { getCashbackList, getCashbackDetail, confirmCashback, rejectCashback } from '@/api/pay'
import { rechargeInfo } from '@/api/refund'
import dayJs from 'dayjs'
export default {
  name: 'ReturnMoneyRecord',
  components: {
    ZfTable,
    ModelPayee
  },
  data() {
    return {
      column,
      form: {
        year: dayJs().format('YYYY')
      },
      tableList: [], // 客户列表
      cashback_sum: '', // 累计返现金额
      mode: 1,
      expireTimeOption: {
        disabledDate(time) {
          // 获取当前月份
          const currentdate = dayJs().format('YYYY')
          const timedate = dayJs(time).format('YYYY')
          return currentdate < timedate
        }
      },
      dialogFormVisible: false,
      detailVisible: false,
      returnMoneyDetail: {},
      detailValue: {
        mch_price: '',
        mch_list: [] // 分配商户号金额
      },
      cashback_id: '', // 返现id
      refuseVisible: false,
      refuseForm: {
        reason: '' // 拒绝原因
      },
      refuseFormRules: {
        reason: [
          { required: true, message: '请输入拒绝原因', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    async query() {
      const query = { ...this.form }
      const res = await getCashbackList(query)
      if (res.code === 200) {
        this.cashback_sum = res.data.cashback_sum
        this.tableList = res.data.list
      }
    },
    resetForm() {
      this.form = {
        year: dayJs().format('YYYY')
      }
      this.query()
    },
    async detail(row) {
      const res = await getCashbackDetail({ recharge_id: row.recharge_id })
      if (res.code === 200) {
        this.returnMoneyDetail = res.data
        this.detailVisible = true
      }
    },
    // 确认充值
    async submitFn(mch_list) {
      const res = await confirmCashback({ mch_list, cashback_id: this.cashback_id })
      if (res.code === 200) {
        this.$message({ type: 'success', message: '提交成功!' })
        this.dialogFormVisible = false
        this.query() // 刷新页面
      }
    },
    async sure(row) {
      const res = await rechargeInfo()
      if (res.code === 200) {
        this.dialogFormVisible = true
        this.cashback_id = row.id // 返现id
        this.detailValue.mch_price = row.mch_price
        this.detailValue.mch_list = res.data.mch_list.map((item) => {
          return {
            ...item,
            price: 0
          }
        })
      }
    },
    refuse(row) {
      this.cashback_id = row.id
      this.refuseVisible = true
    },
    async reasonFn() {
      const res = await rejectCashback({ cashback_id: this.cashback_id, reject_remark: this.refuseForm.reason })
      if (res.code === 200) {
        this.refuseVisible = false
        this.query() // 刷新页面
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.right{
  display: flex;
  align-items:flex-start;
  margin-bottom: 22px;
}
::v-deep{
  .addForm {
    .el-input{
      width: 224px;
    }
    .width100{
      .el-input{
        width: 100%;
      }
      .el-select{
        width: 100%;
      }
    }
  }
  .el-checkbox{
    margin-bottom: 15px;
  }
}
.detail-con{
  .tit{
    font-weight: bold;
    font-size: 16px;
    color: #000;
  }
}
.mch-item{
  background: #FAFAFA;
  padding:  20px;
  margin-bottom: 10px;
  &:last-child{
    margin-bottom: 0;
  }
}
</style>
